<div class="d-flex align-items-center" id="toggleContainer">
  <p-toggleswitch [formControl]="formControl | castTo: FormControl" [disabled]="to?.disabled" [readonly]="to?.disabled">
  </p-toggleswitch>

  @if (to?.disabled && to?.textLabel) {
    <p class="ml-2">
      {{ to?.textLabel }}
    </p>
  }
</div>
